// extracted by mini-css-extract-plugin
export default {"btn":"Subscriberpage_btn__qfKGg","btnc":"Subscriberpage_btnc__7C15r"};